import React from 'react';
import { profileData } from '../../data/profileData';
import { Section } from '../ui';
import Certifications from '../Certifications';
import EPortfolioCard from './EPortfolioCard';
import TechnicalSkills from './TechnicalSkills';
import './Expertise.css';

/** Skills, the AI/ML E-Portfolio, and certifications, grouped as one Expertise section. */
const Expertise: React.FC = () => (
  <Section
    id="expertise"
    title="Expertise"
    eyebrow="Skills & credentials"
    intro="The technologies I work with every day, and the credentials behind them."
    className="expertise-section"
  >
    <TechnicalSkills />
    <EPortfolioCard />
    <Certifications certifications={profileData.certifications} />
  </Section>
);

export default Expertise;
